/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Preview_TitleInputs */

const en_blog_preview_title = /** @type {(inputs: Blog_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article preview`)
};

const lv_blog_preview_title = /** @type {(inputs: Blog_Preview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raksta priekšskatījums`)
};

/**
* | output |
* | --- |
* | "Article preview" |
*
* @param {Blog_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_preview_title = /** @type {((inputs?: Blog_Preview_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Preview_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_preview_title(inputs)
	return en_blog_preview_title(inputs)
});